import { connect } from 'react-redux';
import CentredComponent from './centredComponent';

const mapStateToProps = state => ({
  sidePanelOpen: state.sidebar.isOpen,
  clientWidth: state.clientSize.width,
});

export default connect(mapStateToProps)(CentredComponent);
